import React, { useEffect, useState } from "react";

import { Container, Row, Col, Modal } from "react-bootstrap";
import axios from "axios";
import config from "../config/config";
import BackToTop from "../componentsnew/BackToTop/BackToTop";
import { Link } from "react-router-dom";
import { sweepstakePdf } from "../images";
import CloseX from "../images/locator/close.svg";

const officialRuleData = [
  {
    id: 1,
    title: "Interpretation",
    desc: [
      `This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.`,
      `We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.`,
      `The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.`,
    ],
  },
  {
    id: 2,
    title: "Definitions",
    desc: [
      `<ul>
        <li>For the purposes of this Privacy Policy:</li>
        <li><strong>Business</strong>, for the purpose of the CCPA (California Consumer Privacy Act), refers to the Company as the legal entity that collects Consumers' personal information and determines the purposes and means of the processing of Consumers' personal information, or on behalf of which such information is collected and that alone, or jointly with others, determines the purposes and means of the processing of consumers' personal information, that does business in the State of California.</li>
        <li>Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to House Of Spices (India) Inc., 3000 Marcus Ave Suite 2W10, New Hyde Park, NY 11042.</li>
        <li>Consumer, for the purpose of the CCPA (California Consumer Privacy Act), means a natural person who is a California resident. A resident, as defined in the law, includes (1) every individual who is in the USA for other than a temporary or transitory purpose, and (2) every individual who is domiciled in the USA who is outside the USA for a temporary or transitory purpose.</li>
        <li><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
      </ul>`,
      `Device means any device that can access the Service such as a computer, a cellphone or a digital tablet.`,
    ],
  },
  {
    id: 3,
    title: "Types of Data Collected",
    desc: [
      `For the purposes of the CCPA, Personal Data means any information that identifies, relates to, describes or is capable of being associated with, or could reasonably be linked, directly or indirectly, with You.`,
      `<ol>
        <li>For the purposes of this Privacy Policy:</li>
        <li>Business, for the purpose of the CCPA (California Consumer Privacy Act), refers to the Company as the legal entity that collects Consumers' personal information and determines the purposes and means of the processing of Consumers' personal information, or on behalf of which such information is collected and that alone, or jointly with others, determines the purposes and means of the processing of consumers' personal information, that does business in the State of California.</li>
        <li>Company (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to House Of Spices (India) Inc., 3000 Marcus Ave Suite 2W10, New Hyde Park, NY 11042.</li>
        <li>Consumer, for the purpose of the CCPA (California Consumer Privacy Act), means a natural person who is a California resident. A resident, as defined in the law, includes (1) every individual who is in the USA for other than a temporary or transitory purpose, and (2) every individual who is domiciled in the USA who is outside the USA for a temporary or transitory purpose.</li>
        <li>Cookies are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
        <li>Cookies are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
        <li>Cookies are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
        <li>Cookies are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
        <li>Cookies are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
        <li>Cookies are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
        <li>Cookies are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
      </ol>`,
      `Device means any device that can access the Service such as a computer, a cellphone or a digital tablet.`,
    ],
  },
];

function OfficialRuleModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="rule_modal"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter" className="modal_title">
          Sweepstake's Official Rules
        </Modal.Title>
        <img
          src={CloseX}
          alt="close-modal"
          className="closeModal"
          onClick={props.onHide}
        />
      </Modal.Header>
      <Modal.Body>
        <div className="rule_body_container">
          {/* <div className="rule_body_wrapper"> */}
            {officialRuleData?.map((item, _) => (
              <div className="rule_content_container" key={item?.id}>
                <h2
                  className="rule_title"
                  dangerouslySetInnerHTML={{ __html: item.title }}
                ></h2>
                {item?.desc?.map((desc, i) => (
                  <p
                    className="rule_desc"
                    dangerouslySetInnerHTML={{ __html: desc }}
                  ></p>
                ))}
              </div>
            ))}
          {/* </div> */}
        </div>
      </Modal.Body>
    </Modal>
  );
}

const Footer = () => {
  const [modalShow, setModalShow] = React.useState(false);
  const azure_object_url = config.azure_object_url;
  const [socialLinks, setSocialLinks] = useState([]);
  const [footerContact, setFooterContact] = useState({
    email: null,
    phone: null,
  });

  // Fetch Footer Social Media from API
  useEffect(() => {
    axios
      .get(`${config.api_url}/footer/social`)
      .then((res) => {
        const activeLinks = res.data
          .filter((item) => item.status === true)
          .sort((a, b) => a.order - b.order);
        setSocialLinks(activeLinks);
      })

      .catch((err) => console.log("Error Fetching Social Links:", err));
  }, []);

  useEffect(() => {
    axios
      .get(`${config.api_url}/footer/footer-contact`)
      .then((res) => {
        const email = res.data.find((i) => i.type === "email");
        const phone = res.data.find((i) => i.type === "phone");

        setFooterContact({ email, phone });
      })
      .catch((err) => console.log("Error Fetching Footer Contact:", err));
  }, []);

  return (
    <Container fluid className="CyanBg MainFooter">
      <Row className="justify-content-center">
        <Col className="col-lg-3 mobile-left-leaf px-0">
          <img
            src={process.env.PUBLIC_URL + "/images/white-leaf.png"}
            alt="whiteLeaf"
            className="left-leaf leaf-img img-fluid"
          />
        </Col>
        <Col className="col-lg-6 socialMedia">
          <Row className="socialWrapper">
            {/* <div className="emailPhoneContainer">
              <div className="emailCol">
                <img
                  src={process.env.PUBLIC_URL + "/images/emailIcon.svg"}
                  alt="Email"
                  className="emailIcon img-fluid"
                />
                <div className="px-2  emailIdCol">
                  <span>Email id</span>
                  <span>
                    {" "}
                    <a
                      href="mailto:customerservice@laxmihos.com"
                      target="_blank"
                      rel="noreferrer"
                    >
                      customerservice@laxmihos.com
                    </a>
                  </span>
                </div>
              </div>
              <div className="phoneCol">
                <img
                  src={process.env.PUBLIC_URL + "/images/phone-callIcon.svg"}
                  alt="Email"
                  className="phoneIcon emailIcon img-fluid"
                />
                <div className="px-2 phoneNumberCol">
                  <span>Phone No.</span>
                  <span>
                    {" "}
                    <a href="tel:18334652964">1-833-GOLAXMI</a>
                  </span>
                </div>
              </div>
            </div> */}

            <div className="emailPhoneContainer">
              {/* EMAIL */}
              <div className="emailCol">
                {footerContact.email && (
                  <>
                    <img
                      src={`${azure_object_url}public/${footerContact.email.icon}`}
                      alt="Email"
                      className="emailIcon img-fluid"
                    />
                    <div className="px-2 emailIdCol">
                      <span>{footerContact.email.title}</span>
                      <span>
                        <a href={`mailto:${footerContact.email.value}`}>
                          {footerContact.email.value}
                        </a>
                      </span>
                    </div>
                  </>
                )}
              </div>

              {/* PHONE */}
              <div className="phoneCol">
                {footerContact.phone && (
                  <>
                    <img
                      src={`${azure_object_url}public/${footerContact.phone.icon}`}
                      alt="Phone"
                      className="phoneIcon emailIcon img-fluid"
                    />
                    <div className="px-2 phoneNumberCol">
                      <span>{footerContact.phone.title}</span>
                      <span>
                        <a href={`tel:+${footerContact.phone.value}`}>
                          <span
                            dangerouslySetInnerHTML={{
                              __html:
                                footerContact.phone.formatted ||
                                footerContact.phone.value,
                            }}
                          />
                        </a>
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* <div className="socialLinksContainer">
              <div className="socialLinksItem">
                <a
                  href="https://www.facebook.com/LaxmiFoodsBrand/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={process.env.PUBLIC_URL + "/images/facebook.svg"}
                    alt="whiteLeaf"
                    className="footerIcon img-fluid"
                  />
                </a>
              </div>
              <div className="socialLinksItem">
                <a
                  href="https://www.instagram.com/laxmifoodsbrand/?hl=en"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={process.env.PUBLIC_URL + "/images/instagram.svg"}
                    alt="whiteLeaf"
                    className="footerIcon img-fluid"
                  />
                </a>
              </div>
              <div className="socialLinksItem">
                <a
                  href="https://www.youtube.com/channel/UCA-ojVe3STlOlTOzGzZhYwQ/featured"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={process.env.PUBLIC_URL + "/images/youtube.svg"}
                    alt="whiteLeaf"
                    className="footerIcon img-fluid"
                  />
                </a>
              </div>
              <div className="socialLinksItem">
                <a
                  href="https://www.linkedin.com/company/houseofspices"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={process.env.PUBLIC_URL + "/images/linkedin.svg"}
                    alt="whiteLeaf"
                    className="footerIcon img-fluid"
                  />
                </a>
              </div>
            </div> */}
            <div className="socialLinksContainer">
              {socialLinks.map((item) => (
                <div className="socialLinksItem" key={item._id}>
                  <a href={item.link} target="_blank" rel="noreferrer">
                    <img
                      src={`${azure_object_url}public/${item.icon}`}
                      alt={item.name}
                      className="footerIcon img-fluid"
                    />
                  </a>
                </div>
              ))}
            </div>
            <div className="policyContainer">
              {/* <span className="refLinks">
                <a href="javascript:void(0);" target="_blank">
                  Terms and Conditions
                </a>
              </span>
              <span className="footerBar">|</span> */}
              {/* <span className="refLinks">
                <Link to="/faq">Faq's</Link>
              </span>
              <span className="footerBar">|</span>
              <span className="refLinks">
                <Link to="/contact">Contact Us</Link>
              </span> */}
              {/* <span className="refLinks">
                <button
                  className="popup_btn"
                  onClick={() => setModalShow(true)}
                >
                  Sweepstake's Official Rules
                </button>

                <OfficialRuleModal
                  show={modalShow}
                  onHide={() => setModalShow(false)}
                />
              </span>
              <span className="footerBar">|</span> */}
              <span className="refLinks">
                <a
                  href="https://hosindia.com/privacy-policy"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
              </span>
              <span className="footerBar">|</span>
              <span className="refLinks">Copyrights Reserved @Laxmi</span>
              {/* <span className="footerBar">|</span>
              <span className="refLinks">
                Crafted by{" "}
                <a
                  href="https://www.togglehead.in/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Togglehead.
                </a>
              </span> */}
            </div>
          </Row>
        </Col>
        <Col className="col-lg-3 mobile-right-leaf px-0">
          <img
            src={process.env.PUBLIC_URL + "/images/right-leaf.png"}
            alt="whiteLeaf"
            className="right-leaf leaf-img img-fluid"
          />
        </Col>
      </Row>
      <BackToTop />
    </Container>
  );
};

export default Footer;

// <img
// src={process.env.PUBLIC_URL + "/images/white-leaf.png"}
// alt="whiteLeaf"
// className="btm-left-leaf"
// />
// <img
// src={process.env.PUBLIC_URL + "/images/right-leaf.png"}
// alt="whiteLeaf"
// className="btm-right-leaf"
// />
